export enum BaseSelectionGroupVariant {
  Sharp = 'SHARP',
  Round = 'ROUND',
  // Ghost = 'GHOST', Should be supported in the future
}
